export default __webpack_public_path__ + "static/media/reyna_new.1bd11ffb.png";